/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class InventorySummaryByResourceType extends models.InventorySummaryBase {
    getFixupPrototypeFunction() { return InventorySummaryByResourceType.fixupPrototype; }

    static newInstance(model: Partial<InventorySummaryByResourceType>): InventorySummaryByResourceType {
        let obj = Object.assign(new InventorySummaryByResourceType(), model);
        InventorySummaryByResourceType.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<InventorySummaryByResourceType>): InventorySummaryByResourceType {
        if (!model) return null;
        return InventorySummaryByResourceType.newInstance(<InventorySummaryByResourceType> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: InventorySummaryByResourceType) {
        if (!obj) return;

        models.InventorySummaryByResourceType.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: InventorySummaryByResourceType): boolean {
        if (models.InventorySummaryBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, InventorySummaryByResourceType.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.resources) {
            for (let val of this.resources) {
                models.InventorySummaryByResource.fixupPrototype(val);
            }
        }
    }

    /**
     * Resources this type owns, for example Instances or Key Pairs, largest first
     */
    resources: Array<models.InventorySummaryByResource>;

}
